// Vuex requires Promise https://vuex.vuejs.org/installation.html#promise
import AddContent from './components/Utils/add-content'
import BlogSearch from './views/blog-search'
import KnowledgeLibrarySearch from './views/knowledge-library-search'
import MapsSearch from './views/maps-search'
import MemberBlog from './views/member-blog'
import MemberEvents from './views/member-events'
import MemberNews from './views/member-news'
import MemberProperties from './views/member-properties'
import MemberReports from './views/member-reports'
import MemberSupport from './views/member-support'
import ProfileActions from './components/Utils/profile-actions'
import PropertyAlerts from './views/property-alerts'
import PropertyMap from './views/property-map'
import PropertySearch from './views/property-search'
import PropertySearchMap from './views/property-search-map'
import ResendConfirmationEmail from './components/Utils/resend-confirmation-email'
import SearchStoriesFilters from './components/SiteSearch/search-stories-filters'
import SearchFilters from './components/SiteSearch/search-filters'
import SiteSearch from './views/site-search'
import StaffSearch from './views/staff-search'
import SupportFinderProfileUpdate from './components/Utils/support-finder-profile-update'
import TagButton from './components/Utils/tag-button'
import { createApp } from 'vue'
import VueGoogleMaps from '@/utils/vueGoogleMaps.js'
import { createStore } from './store'

function createEventHub() {
    const listeners = new Map()

    return {
        $emit(eventName, payload) {
            const eventListeners = listeners.get(eventName) || []
            eventListeners.forEach(listener => listener(payload))
        },

        $off(eventName, listener) {
            const eventListeners = listeners.get(eventName)

            if (!eventListeners) {
                return
            }

            listeners.set(eventName, eventListeners.filter(x => x !== listener))
        },

        $on(eventName, listener) {
            listeners.set(eventName, [...(listeners.get(eventName) || []), listener])
        }
    }
}

const store = createStore()
const googleMapsLoadOptions = {
    key: googleMapsApiKey,
    libraries: ['marker'],
    loading: 'async',
    v: 'weekly'
}

const app = createApp({
    components: {
        AddContent,
        BlogSearch,
        KnowledgeLibrarySearch,
        MapsSearch,
        MemberBlog,
        MemberEvents,
        MemberNews,
        MemberProperties,
        MemberReports,
        MemberSupport,
        ProfileActions,
        PropertyAlerts,
        PropertyMap,
        PropertySearch,
        PropertySearchMap,
        ResendConfirmationEmail,
        SearchFilters,
        SiteSearch,
        SearchStoriesFilters,
        StaffSearch,
        SupportFinderProfileUpdate,
        TagButton
    }
})

app.config.globalProperties.$eventHub = createEventHub()
app.use(store)
app.use(VueGoogleMaps, {
    load: googleMapsLoadOptions
})
app.mount('#hie-app')
